import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { classMap as o } from '../../../../node_modules/lit-html/directives/class-map.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { ButtonStyleTypes } from '../../atoms/buttons/enums.js';
import { setDataAttributes, isRTL } from '../../utilities/dom-helpers/index.js';
import { setLineClamp } from '../../utilities/text-helpers/index.js';
import css_248z from './icons-and-info-block.scss.js';

class IconsAndInfoBlock extends s {
    constructor() {
        super(...arguments);
        this.rtl = false;
        this.divider = false;
        this.styleType = ButtonStyleTypes.LIGHT;
        this.headingSlot = null;
        this.textSlot = null;
        this.isIcon = false;
        this.enableSpacing = false;
        this.isLarge = false;
    }
    firstUpdated() {
        setDataAttributes(this, 'heading', null);
        setLineClamp(this, 99, 299);
        this.checkLargeIcons();
        this.handleLargeIcons(this.isLarge);
        IconsAndInfoBlock.ctaClasses();
    }
    checkLargeIcons() {
        const icons = Array.from(this.querySelectorAll('icon-and-info'));
        const hasLargeIcons = icons.some(icon => icon.getAttribute('size') === 'Large');
        this.isLarge = hasLargeIcons;
        return hasLargeIcons;
    }
    handleLargeIcons(largeAttr) {
        if (!largeAttr)
            return;
        const iconsContainer = this.querySelector('.icons-container-slotted');
        iconsContainer === null || iconsContainer === void 0 ? void 0 : iconsContainer.classList.add('icons-container-slotted--large');
    }
    static ctaClasses() {
        const ctaButtons = document.querySelectorAll('generic-button span');
        const filteredCta = Array.from(ctaButtons).filter(span => !span.closest('a.primary-button.style-dark.size-regular'));
        filteredCta.forEach(cta => {
            cta.classList.add('icon-cta');
        });
    }
    static handleSlotChange(event) {
        const slot = event.target;
        const assignedElements = slot.assignedElements({ flatten: true });
        const iconsContainer = assignedElements.find(el => el.classList && el.classList.contains('icons-container-slotted'));
        if (iconsContainer) {
            const icons = Array.from(iconsContainer.querySelectorAll('icon-and-info'));
            IconsAndInfoBlock.setGrid(iconsContainer, icons.length);
            icons.forEach((icon, index) => {
                icon.classList.remove('grid-item-1', 'grid-item-2', 'grid-item-3', 'grid-item-4', 'grid-item-5');
                icon.classList.add(`grid-item-${index + 1}`);
            });
        }
    }
    static setGrid(iconsContainer, icons) {
        switch (icons) {
            case 2:
                iconsContainer.classList.add('icons-container-slotted--grid-2');
                break;
            case 3:
                iconsContainer.classList.add('icons-container-slotted--grid-3');
                break;
            case 4:
                iconsContainer.classList.add('icons-container-slotted--grid-4');
                break;
            case 5:
                iconsContainer.classList.add('icons-container-slotted--grid-5');
                break;
            case 6:
                iconsContainer.classList.add('icons-container-slotted--grid-6');
                break;
            case 7:
                iconsContainer.classList.add('icons-container-slotted--grid-7');
                break;
            case 8:
                iconsContainer.classList.add('icons-container-slotted--grid-8');
                break;
        }
    }
    static createCardAlignmentScript() {
        const script = document.createElement('script');
        script.textContent = `
      (function() {
        if (window.iconsAndInfoBlockAlignmentInitialized) {
          return;
        }
        window.iconsAndInfoBlockAlignmentInitialized = true;

        function alignIconAndInfoCards() {
          const containers = document.querySelectorAll('.icons-container-slotted');
          if (containers.length === 0) return;
          containers.forEach(container => {
            const cards = container.querySelectorAll('icon-and-info');
            if (cards.length === 0) return;
            if (cards.length === 3) {
              container.classList.add('three-cards');
            } else {
              container.classList.remove('three-cards');
            }

            cards.forEach(card => {
              const sections = ['[slot="icon"]', '[slot="heading"]', '[slot="text"]', '[slot="cta"]'];
              sections.forEach(selector => {
                const section = card.querySelector(selector);
                if (section) {
                  section.style.height = 'auto';
                  section.style.minHeight = 'auto';
                }
              });
              card.style.height = 'auto';
            });

            requestAnimationFrame(() => {
              let cardsPerRow;
              if (window.innerWidth <= 768) {
                cardsPerRow = 1;
              } else {
                if (cards.length === 1) {
                  cardsPerRow = 1;
                } else if (cards.length === 2) {
                  cardsPerRow = 2;
                } else if (cards.length === 3) {
                  cardsPerRow = 3;
                } else if (cards.length === 4) {
                  cardsPerRow = 4; 
                } else {
                  cardsPerRow = 3; 
                }
              }
              
              for (let rowStart = 0; rowStart < cards.length; rowStart += cardsPerRow) {
                const rowCards = Array.from(cards).slice(rowStart, rowStart + cardsPerRow);
                
                const sections = ['[slot="icon"]', '[slot="heading"]', '[slot="text"]', '[slot="cta"]'];
                const rowMaxHeights = {};
                
                sections.forEach(selector => {
                  let maxHeight = 0;
                  rowCards.forEach(card => {
                    const section = card.querySelector(selector);
                    if (section) {
                      const height = section.offsetHeight;
                      if (height > maxHeight) {
                        maxHeight = height;
                      }
                    }
                  });
                  rowMaxHeights[selector] = maxHeight;
                });
                
                rowCards.forEach(card => {
                  sections.forEach(selector => {
                    const section = card.querySelector(selector);
                    if (section && rowMaxHeights[selector] > 0) {
                      section.style.height = rowMaxHeights[selector] + 'px';
                      section.style.display = 'flex';
                      section.style.flexDirection = 'column';
                      section.style.justifyContent = selector === '[slot="icon"]' ? 'center' : 'flex-start';
                    }
                  });
                });
              }
            });
          });
        }

        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', alignIconAndInfoCards);
        } else {
          setTimeout(alignIconAndInfoCards, 100);
        }

        if (!window.iconsAndInfoBlockResizeTimeout) {
          window.iconsAndInfoBlockResizeTimeout = null;
        }

        window.addEventListener('resize', () => {
          clearTimeout(window.iconsAndInfoBlockResizeTimeout);
          window.iconsAndInfoBlockResizeTimeout = setTimeout(alignIconAndInfoCards, 250);
        });

        const observer = new MutationObserver((mutations) => {
          let shouldAlign = false;
          mutations.forEach((mutation) => {
            if (mutation.type === 'childList' || mutation.type === 'characterData') {
              shouldAlign = true;
            }
          });
          if (shouldAlign) {
            setTimeout(alignIconAndInfoCards, 150);
          }
        });

        setTimeout(() => {
          const containers = document.querySelectorAll('.icons-container-slotted');
          containers.forEach(container => {
            observer.observe(container, {
              childList: true,
              subtree: true,
              characterData: true
            });
          });
          if (containers.length > 0) {
            alignIconAndInfoCards();
          }
        }, 50);
      })();
    `;
        return script;
    }
    render() {
        const classes = {
            'icons-and-info-block': true,
            [this.styleType.toLowerCase()]: this.styleType,
            rtl: this.rtl || isRTL(),
            divider: this.divider,
            'icons-grid-container': true,
            'default-space-between-cards': this.enableSpacing,
        };
        return $ `<div class="${o(classes)}"><hr class="separator"><header><slot name="heading"></slot></header><div class="icons-container"><slot name="icons" @slotchange="${IconsAndInfoBlock.handleSlotChange}"></slot></div><slot name="cta" class="cta-container"></slot>${IconsAndInfoBlock.createCardAlignmentScript()}</div>`;
    }
}
IconsAndInfoBlock.styles = css_248z;
__decorate([
    e({ type: Boolean, reflect: true })
], IconsAndInfoBlock.prototype, "rtl", void 0);
__decorate([
    e({ type: Boolean, reflect: true })
], IconsAndInfoBlock.prototype, "divider", void 0);
__decorate([
    e({ type: String, reflect: true })
], IconsAndInfoBlock.prototype, "styleType", void 0);
__decorate([
    t()
], IconsAndInfoBlock.prototype, "headingSlot", void 0);
__decorate([
    t()
], IconsAndInfoBlock.prototype, "textSlot", void 0);
__decorate([
    e({ type: Boolean })
], IconsAndInfoBlock.prototype, "isIcon", void 0);
__decorate([
    e({ type: Boolean, reflect: true })
], IconsAndInfoBlock.prototype, "enableSpacing", void 0);
__decorate([
    t()
], IconsAndInfoBlock.prototype, "isLarge", void 0);
customElements.define('icons-and-info-block', IconsAndInfoBlock);

export { IconsAndInfoBlock };
